import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const FormPayment = () => {
	const { sessionId } = useParams();
	const history = useHistory();

	useEffect(() => {
		setTimeout(() => {
			history.push("/");
		}, 10000);
	}, []);

	return (
		<div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
			<Helmet>
				<meta charSet="utf-8" />
				<title>Escuela Tecnificación RFEF</title>
			</Helmet>

			<div style={{ padding: "15px 20px", width: "100%", flex: 1, display: "flex", flexDirection: "column", maxWidth: 960, alignSelf: "center", boxSizing: "border-box" }}>
				{!sessionId ? (
					<div style={{ display: "flex", flexGrow: 1, flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
						<div style={{ padding: 20, marginTop: 15, maxWidth: 600, marginBottom: 15, backgroundColor: "#DFDFDF", borderRadius: 10, textAlign: "center" }}>
							<p style={{margin: 0, fontSize: 18, textAlign:"center" }}>El pago no se ha completado correctamente o el enlace que has seguido es incorrecto</p>
						</div>
					</div>
				) : (
					<div style={{ display: "flex", flexGrow: 1, flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
						<div style={{ padding: 20, marginTop: 15, maxWidth: 600, marginBottom: 15, backgroundColor: "#DFDFDF", borderRadius: 10, textAlign: "center" }}>
							<p style={{ margin: 0, fontSize: 18, textAlign:"center" }}>El pago ha sido realizado y se está confirmando. Recibirás un email en breves instantes, cuando todo esté listo.</p>
							<img
								src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Royal_Spanish_Football_Federation_logo.svg/1200px-Royal_Spanish_Football_Federation_logo.svg.png"
								width={"auto"}
								height={200}
								style={{ margin: "0px auto" }}
							/>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default FormPayment;
